import { Button } from "PFComponents/button";
import React from "react";
import { useTranslation } from "react-i18next";

interface ExportButtonProps {
  onClick: () => void;
}

export const ExportButton = ({ onClick }: ExportButtonProps): JSX.Element => {
  const { t } = useTranslation("bookingModule", { keyPrefix: "reports" });
  return <Button text={t("export")} kind="text" onClick={onClick} />;
};
